export const UPDATE_ADDRESS = "containers/AddressSearchInput/UPDATE_ADDRESS"
export const REQUEST = "containers/AddressSearchInput/REQUEST"
export const RECEIVE = "containers/AddressSearchInput/RECEIVE"
